export default function getPositionOffset(element) {
  let currentTop = 0;
  if (element?.offsetParent) {
    do {
      currentTop += element.offsetTop;
    } while ((element = element.offsetParent));
  }
  return currentTop;
}
